module.exports = __webpack_public_path__ + "static/media/item_2_8.7e024730.png";